<template>
  <div class="authorization-page">
    <div class="decompression-start" />
    <!-- 星星 -->
    <img
      src="../assets/image/start-one.png"
      class="star-twinkle1"
    >
    <img
      src="../assets/image/start-two.png"
      class="star-twinkle2"
    >
    <img
      src="../assets/image/start-two.png"
      class="star-twinkle3"
    >
    <!-- 流星 -->
    <img
      class="meteor1"
      src="../assets/image/meteor-img1.png"
      alt=""
    >
    <img
      class="meteor2"
      src="../assets/image/meteor-img2.png"
      alt=""
    >
    <img
      class="meteor3"
      src="../assets/image/meteor-img1.png"
      alt=""
    >
    <div class="text-content">
      <p>Hi， 陈伊洋同学</p>
      <p>欢迎来到减压星球</p>
      <p>我是你的旅伴：小星</p>
      <p>......</p>
      <p>在未来的旅程中</p>
      <p>我会陪伴在你的身边</p>
      <p>倾听你的烦恼和困扰</p>
      <p>帮你减轻压力，获得自信</p>
      <p>是我的愿望!</p>
    </div>
    <div class="start-button start-button1" />
    <div
      class="blue-bg"
      @click="goJourney"
    >
      开启旅程
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data () {
    return {
      disable: true
    }
  },
  created () {
    setTimeout(() => {
      this.disable = false
    }, 7000)
  },
  methods: {
    showDetial (code) {
      if (code === 1) {
        this.$router.push('/home')
      } else {
        if (this.careerRequires) {
          this.$router.push('/careerHome')
        } else {
          Toast('生涯应用授权失败')
        }
      }
    },
    goJourney () {
      if (this.disable) return
      this.$router.push("/interactive")
    }
  },
}
</script>

<style lang="scss">
// 星球上下浮动动画
@keyframes star-fall {
  0% {
    top: 49.41%;
  }
  50% {
    top: 45.41%;
  }
  100% {
    top: 49.41%;
  }
}
@keyframes star-fall2 {
  0% {
    top: 12%;
  }
  40% {
    top: 15%;
  }
  100% {
    top: 10%;
  }
}

// 星星闪烁动画
@keyframes star-twinkle {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes star-twinkle2 {
  0% {
    opacity: 0.5;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@keyframes star-twinkle3 {
  0% {
    opacity: 0.7;
  }
  30% {
    opacity: 1;
  }
  65% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@keyframes star-twinkle4 {
  0% {
    opacity: 0.2;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
@keyframes star-twinkle5 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
// meteor  流星动画
@keyframes meteor1 {
  0% {
    left: 40%;
    top: -140px;
  }
  100% {
    width: 128px;
    height: 138px;
    left: -5%;
    top: 100%;
  }
}
@keyframes meteor2 {
  0% {
    left: 80%;
    top: -140px;
  }
  100% {
    width: 0;
    height: 0;
    opacity: 0;
    left: 35%;
    top: 80%;
  }
}
@keyframes meteor3 {
  0% {
    left: 100%;
    top: 25%;
  }
  100% {
    left: 70%;
    top: 100%;
  }
}
// 文字开场动画
@keyframes text-content {
  0% {
    top: 100%;
    opacity: 0;
  }
  66% {
    top: 18.67%;
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

@keyframes start-button1 {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1.35);
  }
}
@keyframes blue-bg {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.authorization-page {
  position: relative;
  height: 100%;
  width: 100%;
  background: url("../assets/image/gauge-page-bg.png") no-repeat 0 0/ 100% 100%;
  overflow: hidden;
  .decompression-start {
    position: absolute;
    width: 231px;
    height: 284px;
    left: 170px;
    top: 49.41%;
    z-index: 10;
    animation: star-fall 6s ease-in-out infinite alternate;
    background: url("../assets/image/astronaut-img.png") no-repeat 0 0/100% 100%;
    // & .decompression-start-icon {
    //   width: 207px;
    //   height: 64px;
    //   position: absolute;
    //   left: 178px;
    //   bottom: 146px;
    //   font-size: 26px;
    //   font-family: FZZZHONGJW--GB1-0, FZZZHONGJW--GB1;
    //   font-weight: normal;
    //   color: #fff7d9;
    //   line-height: 64px;
    //   text-shadow: 0px 0px 4px rgba(54, 22, 22, 0.5);
    //   text-align: center;
    //   background: url("../assets/careerImage/decompression-start-icon.png")
    //     no-repeat 0 0/100% 100%;
    // }
  }
  // .career-start {
  //   position: absolute;
  //   width: 510px;
  //   height: 510px;
  //   background: yellow;
  //   right: 400px;
  //   top: 12%;
  //   z-index: 10;
  //   background: url("../assets/careerImage/career-start-img.png") no-repeat 0 0/100%
  //     100%;
  //   animation: star-fall2 6s ease-in-out infinite alternate;
  //   & .career-start-icon {
  //     width: 207px;
  //     height: 64px;
  //     position: absolute;
  //     left: 178px;
  //     bottom: 146px;
  //     font-size: 26px;
  //     font-family: FZZZHONGJW--GB1-0, FZZZHONGJW--GB1;
  //     font-weight: normal;
  //     color: #fff7d9;
  //     line-height: 64px;
  //     text-shadow: 0px 0px 4px rgba(54, 22, 22, 0.5);
  //     text-align: center;
  //     background: url("../assets/careerImage/career-start-icon.png") no-repeat 0
  //       0/100% 100%;
  //   }
  // }
  .star-twinkle1 {
    position: absolute;
    left: 121px;
    top: 503px;
    width: 86px;
    height: 86px;
    opacity: 1;
    animation: star-twinkle 1.5s ease-in-out infinite alternate;
  }

  .star-twinkle2 {
    position: absolute;
    left: 1498px;
    top: 235px;
    width: 94px;
    height: 94px;
    opacity: 0.5;
    animation: star-twinkle2 2s linear infinite alternate;
  }
  .star-twinkle3 {
    position: absolute;
    left: 1351px;
    top: 735px;
    width: 98px;
    height: 97px;
    opacity: 0.7;
    animation: star-twinkle3 2s linear infinite alternate;
  }
  // .star-twinkle4 {
  //   position: absolute;
  //   left: 1733px;
  //   top: 17%;
  //   width: 5px;
  //   height: 5px;
  //   border-radius: 50%;
  //   background: #fff;
  //   opacity: 0.2;
  //   animation: star-twinkle4 3s linear infinite alternate;
  // }
  // .star-twinkle5 {
  //   position: absolute;
  //   left: 1763px;
  //   top: 75%;
  //   width: 7px;
  //   height: 7px;
  //   border-radius: 50%;
  //   background: #fff;
  //   opacity: 0;
  //   animation: star-twinkle5 2s linear infinite alternate;
  // }
  // .star-twinkle6 {
  //   position: absolute;
  //   left: 1733px;
  //   top: 17%;
  //   width: 7px;
  //   height: 7px;
  //   border-radius: 50%;
  //   background: #fff;
  //   opacity: 0.2;
  //   animation: star-twinkle4 3s linear infinite alternate;
  // }
  .text-content {
    position: absolute;
    left: 754px;
    top: 18.67%;
    width: 420px;
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bdbad5;
    line-height: 52px;
    letter-spacing: 1px;
    animation: text-content 4s linear 1 normal;
    p {
      font-size: 36px;
    }
  }
  .start-button {
    opacity: 0;
    position: absolute;
    left: 880px;
    bottom: 11.67%;
    width: 160px;
    height: 160px;
    background: url("../assets/image/journey-bg.png") no-repeat 0 0/ 100% 100%;
  }
  .start-button1 {
    animation: blue-bg 2s linear 5s 1 normal,
      start-button1 1.5s linear 7s infinite alternate;
    animation-fill-mode: forwards;
  }
  // .start-button2 {
  //   animation: start-button1 1.5s linear 1s infinite normal;
  // }
  .blue-bg {
    opacity: 0;
    position: absolute;
    left: 880px;
    bottom: 11.67%;
    width: 160px;
    height: 160px;
    background: #00baff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 47px;
    border-radius: 50%;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    animation: blue-bg 2s linear 5s 1 normal;
    animation-fill-mode: forwards;
    cursor: pointer;
  }
  .meteor1 {
    position: absolute;
    left: 40%;
    top: -140px;
    width: 64px;
    height: 69px;
    animation: meteor1 5s linear infinite;
  }
  .meteor2 {
    position: absolute;
    left: 80%;
    top: -140px;
    width: 100px;
    height: 76px;
    animation: meteor2 7s linear infinite;
  }
  .meteor3 {
    position: absolute;
    left: 100%;
    top: 45%;
    width: 71px;
    height: 54px;
    animation: meteor3 4s linear infinite;
  }
}
</style>
